module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false
    },
    on: {
      "close": _vm.clearSelectedItem
    }
  }, [(_vm.getSelectedItem) ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Product details")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.getSelectedItem.name))])]) : _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("New Product")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Details"
    }
  }, [_c('product-edit')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Schedule"
    }
  }, [_c('product-schedule')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Prices"
    }
  }, [_c('product-prices')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Extras"
    }
  }, [_c('product-extras')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Payments"
    }
  }, [_c('product-payments')], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5235bf84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5235bf84"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ProductView.vue
// module id = 1038
// module chunks = 0